const popupNewsletter = {
	init(partentPopup) {
		const tpMoDal = document.querySelector(partentPopup);
		const offCheckbox = document.querySelector('#offNewsletterCheckbox');
		const expiresToSec = tpMoDal.dataset.expires;
		const overlayNewsletter = document.querySelector('.tp-close-overlay');
		this.closePopupNewsletter(tpMoDal, overlayNewsletter);
		this.checkBoxOff(offCheckbox, expiresToSec, tpMoDal, overlayNewsletter);
		this.checkFormInfo(expiresToSec, overlayNewsletter);
		const keyCookie = this.getCookie('tp_popup_newsletter');
		if (keyCookie != 'closed') {
			this.openPopupNewsletter(tpMoDal, overlayNewsletter);
		}
	},
	checkBoxOff(offCheckbox, expiresToSec, tpMoDal, overlayNewsletter) {
		offCheckbox?.addEventListener('change', () => {
			if (offCheckbox.checked) {
				this.setCookie('tp_popup_newsletter', 'closed', expiresToSec);
			}
		})
	},
	setCookie(cname, cvalue, expiresToSec) {
		if (expiresToSec != 0) {
			const d = new Date();
			d.setTime(d.getTime() + expiresToSec * 24 * 60 * 60 * 1000);
			let expires = 'expires=' + d.toUTCString();
			document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
		}
	},
	getCookie(cname) {
		let name = cname + '=';
		let decodedCookie = decodeURIComponent(document.cookie);
		let ca = decodedCookie.split(';');
		for (let i = 0; i < ca.length; i++) {
			let c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return '';
	},
	openPopupNewsletter(tpMoDal, overlayNewsletter) {
		const dataDelay = tpMoDal.dataset.delay;
		setTimeout(function () {
			tpMoDal.classList.remove('hidden');
			overlayNewsletter.classList.add('is-visible-newsletter');
			document.querySelector('html').classList.add('tp-over-flow-hidden-subc')
		}, dataDelay);
	},

	closePopupNewsletter(tpMoDal, overlayNewsletter) {
		document.addEventListener('click', function (e) {
			const el = e.target;
			if (el.classList.contains('tp-modal-subsc--close') || el == tpMoDal) {
				tpMoDal.classList.add('hidden');
				overlayNewsletter.classList.remove('is-visible-newsletter');
				document.querySelector('html').classList.remove('tp-over-flow-hidden-subc')
			}
		})
	},
	checkFormInfo(expiresToSec, overlayNewsletter) {
		const _this = this;
		const urlInfo = window.location.href;
		const formInfo = document.querySelector('.form-infor');
		const formErr = document.querySelector('.form-infor-body.noti-error');
		const formSuccess = document.querySelector('.form-infor-body.noti-success');
		document.querySelector('.form-infor,.close-form-info').addEventListener('click', (e) => {
			const target = e.currentTarget;

			const closet = target.closest('.form-infor');
			e.preventDefault();
			if (closet.classList.contains('show-noti-form')) {
				closet.classList.remove('show-noti-form')
				overlayNewsletter.classList.remove('is--visible-form-info');
				document.querySelector('html').classList.remove('tp-over-flow-hidden-form-info');
			};
		});
		if (urlInfo.indexOf('customer_posted=true') >= 1) {
			formInfo.classList.add('show-noti-form');
			overlayNewsletter.classList.add('is--visible-form-info');
			document.querySelector('html').classList.add('tp-over-flow-hidden-form-info');
			formErr.style.display = "none";
			_this.setCookie('tp_popup_newsletter', 'closed', expiresToSec);
			const newURL = location.href.split("?")[0];
			window.history.pushState('object', document.title, newURL);
		};
		if (urlInfo.indexOf('contact%5Btags%5D=newsletter&form_type=customer') >= 1) {
			formInfo.classList.add('show-noti-form');
			overlayNewsletter.classList.add('is--visible-form-info');
			document.querySelector('html').classList.add('tp-over-flow-hidden-form-info')
			formSuccess.style.display = "none";
			const newURL = location.href.split("?")[0];
			window.history.pushState('object', document.title, newURL);
		}
	}
}
const partentPopup = '.tp-modal-subsc';
if (document.querySelector(partentPopup)) {
	popupNewsletter.init(partentPopup);
}